export default function () {
  const moduleName = 'scrollToAnchor'
  Array.from(document.querySelectorAll('a[href^="#anchor-"]')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init'] === 'true') return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    const settings = {
      duration: 600
    }

    wrapper.addEventListener('click', (event) => {
      event.preventDefault()

      const href = wrapper.getAttribute('href')

      document.querySelector(href).scrollIt({
        duration: settings.duration,
        easing: 'easeInQuad',
        callback: () => {
          window.location.hash = href
        }
      })
    })
  })
};
